<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">系统管理</li>
      </ul>
    </div>-->
    <el-tabs
      class="tabLv3"
      type="border-card"
      v-model="tabName"
    >
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 模板短信管理
        </span>

        <div class="tableWrapper">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/messageConfig/findAll"
            :parent="self"
            :config="config"
            :other="other"
            ref="role"
          >
            <template slot="last">

              <el-table-column
                label="模板内容"
                width="800"
                align="center"
              >
                <template slot-scope="scope">
                  <p v-html='scope.row.template2'></p>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="300"
                align="center"
              >
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.$index, scope.row)"
                  >编辑</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <el-dialog
          class="editDialog"
          :visible.sync="dialogForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form
            :model="formMsg"
            ref="formMsg"
            :rules="rules"
          >
            <el-button-group>
              <h1 class="operationTip">操作说明:<br />
                1,选中文本框开始编辑。<br />
                2,若用到具体的变量值可点击上方的变量，插入到当前的光标处<br />
              </h1>

              <el-button
                :key="id"
                @click="add(note)"
                v-for="({note,id}) in messageVariableList"
                type="mini"
              >{{note}}</el-button>
            </el-button-group>
            <el-form-item
              label="模板内容"
              prop="remark"
            >
              <div
                class="contenteditable"
                contenteditable="true"
                ref="contenteditable"
              ></div>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            class="dialog-footer"
          >
            <el-button
              class="cancelButton"
              @click="dialogForm = false"
            >取消</el-button>
            <el-button
              class="confirmButton"
              type="primary"
              @click="submitAdd"
            >确定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      loading: true,
      title: "",
      tabName: "jsgl",
      form_jsgl: {},
      other: {},
      formMsg: {},
      //校验
      rules: {
        name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入备注",
            trigger: "blur",
          },
        ],
        // permission: [{ required: true,}]
      },
      messageVariableList: [],
      dialogForm: false,
      row: null,
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "模板名称",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable"),
  },
  methods: {
    //修改
    edit(index, row) {
      this.title = "修改模板";
      this.row = row;
      this.messageVariableList = row.messageVariableList;
      this.dialogForm = true;
      this.$nextTick(() => {
        let element = this.$refs["contenteditable"];
        element.innerHTML = this.row.template2;
      });
    },
    add(note) {
      let element = this.$refs["contenteditable"];
      let tagId = "tag_" + new Date().getTime();
      let range = window.getSelection().getRangeAt(0);
      let tag = document.createElement("span");
      let space = document.createTextNode(" ");
      tag.id = tagId;
      tag.className = "el-tag el-tag--info el-tag--mini";
      tag.setAttribute("contenteditable", false);
      tag.innerText = note;
      if (
        range.commonAncestorContainer.parentElement.className ==
          "contenteditable" ||
        (element.innerText == "" &&
          range.commonAncestorContainer.className == "contenteditable")
      ) {
        range.insertNode(space);
        range.insertNode(tag);
        this.setFocus(element, space);
      }
    }, // 设置光标位置
    setFocus(element, space) {
      //element.focus();
      // Clear any current selection
      const selection = window.getSelection();
      selection.removeAllRanges();

      // Select paragraph
      const range = document.createRange();
      range.selectNodeContents(space);
      range.collapse(false);
      selection.addRange(range);
    },
    submitAdd() {
      let element = this.$refs["contenteditable"];
      let text = element.innerText;
      this.messageVariableList.forEach(({ note, variable }) => {
        text = text.replaceAll(note, variable);
      });
      this.$axiospost("/operation/messageConfig/updateMessageConfig", {
        id: this.row.id,
        name: this.row.name,
        template: text.replace(/\s*/g, ""),
        template2: element.innerHTML,
      }).then((res) => {
        this.$message.success("提交成功");
        this.dialogForm = false;
        this.$refs["role"].getData();
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}

.el-input__inner:focus {
  border: 1px solid #3587c7;
}

.editDialog {
  .role_tree {
    width: 310px;
    border: 1px solid #3d4963;
    background: transparent;
    color: #cacaca;
  }
}

.contenteditable {
  width: 400px;
  height: 200px;
  border: 1px solid #999;
  margin-bottom: 15px;
  caret-color: red;
}

.space {
  display: inline-block;
  height: 32px;
  line-height: 30px;
  width: 0px;
}
.operationTip{
  font-size: 12px;
  color: #cacaca;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/sms/index.vue